import(/* webpackMode: "eager" */ "/home/runner/work/personal-website/personal-website/app/[slug]/page.tsx");
